'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidRestaurant = function IoAndroidRestaurant(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.1 21.9l-7.1-7c-2.7-2.6-2.7-6.7 0-9.3l11.9 11.6z m11.5-3l-2.6 2.4 11.8 11.4-2.4 2.3-11.7-11.4-11.7 11.4-2.4-2.3s12.8-12.5 16.5-16.2c-1.1-2.5-0.3-6 2.4-8.7 3.2-3.1 7.9-3.8 10.4-1.3 2.5 2.4 1.8 6.9-1.4 10.1-2.6 2.6-6.2 3.5-8.9 2.3z' })
        )
    );
};

exports.default = IoAndroidRestaurant;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-restaurant.js
// module id = 2137
// module chunks = 0